"use client";

import { refreshTprWorkflowProgress } from "@/configuration/groups/tpr/components/workflow-progress";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { toast } from "@/src/hooks/use-toast";
import { useApproveTaskMutation, useLocalTaskUpdateMutation } from "@/src/lib/data-fetchers/tasks-fetchers";
import { type Task, TaskStatus } from "@/src/models/task";

export function TprReceivingAssignmentContinueButton({ task }: { task: Task }) {
  const approvalMutation = useApproveTaskMutation();
  const localTaskUpdateMutation = useLocalTaskUpdateMutation({ invalidateOnSettled: false });
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");

  const handleContinue = async () => {
    try {
      await approvalMutation.mutateAsync({ taskId: task.id, approved: true });
      localTaskUpdateMutation.mutate({ ...task, status: TaskStatus.PROCESSING });
      refreshTprWorkflowProgress(invalidateInstructions);
      toast({
        title: "Receiving assignment confirmed",
        description: "The workflow is continuing with the remaining applicable steps.",
      });
    } catch (error) {
      toast({
        title: "Unable to continue the workflow",
        description: error instanceof Error ? error.message : "Refresh the task and try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button
      size="sm"
      onClick={handleContinue}
      disabled={approvalMutation.isPending || localTaskUpdateMutation.isPending}
    >
      {approvalMutation.isPending ? "Continuing..." : "Continue"}
    </Button>
  );
}
